import React, { useState } from "react";
import "../../styles/blog.css";
import InnerBanner from "../../common/InnerBanner";
import Input from "../../common/Input";
import Pagination from "../../common/Pagination";

const BlogPg = () => {
  const [activePg, setActivePg] = useState(1);

  return (
    <>
      <InnerBanner name="Blog" />
      <div className="blog_main container">
        <div className="blog_left dm-sans">
          <Input placeholder={"Search"} icon={"bi-search"} />

          <div className="popular_post">
            <h4 className="popular_post_head">Popular post</h4>
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="pop_post">
                <img src="/img/blog/blog-1.webp" alt="blog" />
                <div className="pop_post_cnt">
                  <h5>Fahion Watch</h5>
                  <span>19 Augs, 2019 - by John</span>
                </div>
              </div>
            ))}
          </div>
          <div className="popular_post">
            <h4 className="popular_post_head">Categories</h4>
            {[14, 26, 39, 41, 5, 6, 12, 54].map((item) => (
              <div key={item} className="pop_post">
                <div className="pop_post_categories">
                  <h6>Fahion Watch</h6>
                  <span>({item})</span>
                </div>
              </div>
            ))}
          </div>
          <div className="popular_post">
            <h4 className="popular_post_head">Archives</h4>
            <select name="cars" id="cars" className="archives_select">
              <option value="volvo">Volvo</option>
              <option value="saab">Saab</option>
              <option value="mercedes">Mercedes</option>
              <option value="audi">Audi</option>
            </select>
          </div>

          <div className="popular_post popular_tags">
            <h4 className="popular_post_head">Tags</h4>
            <span className="popular_post_tags">
              Beauty, Life Style, Technology, Design, Fashion, Furniture,
              Travel, Photography, Motion Design
            </span>
            <div className="popular_tags_img">
              <h3>Add Banner</h3>
              <h5>info@gmail.com</h5>
            </div>
          </div>
          <Input placeholder={"Email  "} icon={"bi-envelope"} />
        </div>
        <div className="blog_right dm-sans">
          {[1, 2, 3, 4, 5].map((item) => (
            <div className="blog_right_one" key={item}>
              <div className="blog_right_inner_img overflow-hidden">
                <img src="/img/blog/blog-2.webp" alt="blog" />
              </div>

              <h3>Always Look On The Bright Side Of Life</h3>
              <span>By by John Snow - April 17,2019</span>
              <p>
                Ut tempus leo sed magna hendrerit, non congue libero blandit.
                Vestibulum libero diam, convallis in arcu ut, semper vulputate
                dolor. Vestibulum ante ipsum primis in faucibus orci luctus et
                ultrices posuere cubilia Curae usce luctus fringilla fermentum…
              </p>
              <button>Read More</button>
            </div>
          ))}
          <Pagination setActivePg={setActivePg} activePg={activePg} />
        </div>
      </div>
    </>
  );
};

export default BlogPg;
